import { supabaseClient } from "@/supabase/app";
import { enqueueSnackbar } from "notistack";

export interface TeamMember {
  id?: string;
  email: string;
//   domain_name: string;
//   created_at: string;
}

export async function getAllInvites(id: string): Promise<TeamMember[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .select("*")
      .eq("user_id", id);

    if (error) {
      throw error;
    }
    return data as TeamMember[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getInvites(): Promise<TeamMember[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .select("*")
      // .eq("user_id", id);

    if (error) {
      throw error;
    }
    return data as TeamMember[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}


export async function getInviteById(id: number) {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      throw error;
    }

    return data; // Return the profile data
  } catch (error) {
    enqueueSnackbar(`Error fetching profile: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function addMember(formData: any, message: string) {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .insert([formData])
      .select() 
      .single(); 

    if (error) {
      throw error;
    }

    console.log(data, "Inserted data"); // Log the returned data

    enqueueSnackbar(message, {
      variant: "success",
    });

    return data; // Return the specific object data after adding
  } catch (error) {
    enqueueSnackbar(`Error adding profile: ${error.message}`, {
      variant: "error",
    });
    return null; // Optionally return null or undefined to indicate failure
  }
}

export async function updateTeamMember(
  profileId: string,
  updatedData: Partial<TeamMember>,
  message: string
) {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .update(updatedData)
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar(message, {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error updating profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function deleteTeamMember(profileId: string) {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .delete()
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar("TeamMember Deleted Successfully", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function deleteTeamMembers(profileIds: string[]) {
  try {
    const { data, error } = await supabaseClient
      .from("invited_members")
      .delete()
      .in("id", profileIds); // using 'in' to match any of the IDs in the array

    if (error) {
      throw error;
    }

    enqueueSnackbar("Team Members Deleted Successfully", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting invited_members: ${error.message}`, {
      variant: "error",
    });
  }
}
